import { CircularProgress as MuiCircularProgress, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    color: ({ color }) => theme.colors[color] ?? color ?? theme.colors.greyCc,
  },
}));

const CircularProgress = React.forwardRef((props, ref) => {
  const { className, color, ...otherProps } = props;
  const classes = useStyles({ color });

  return (
    <MuiCircularProgress
      ref={ref}
      size={16}
      className={classNames(classes.root, className)}
      {...otherProps}
    />
  );
});

CircularProgress.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};
CircularProgress.defaultProps = {
  className: undefined,
  color: undefined,
};

export default CircularProgress;
